var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "submenu",
      class: _vm.bemBlockMod({
        open:
          !(_vm.isBreakpointDesktop && _vm.isComplexSubmenuChild) && _vm.isOpen,
        complex: _vm.hasComplexSubCategories,
        block: _vm.isParentBlockCategory
      }),
      style: _vm.cssCustomProps
    },
    [
      !_vm.isBreakpointDesktop
        ? _c(
            "button",
            {
              class: [_vm.bemElement("back"), "btn", "btn--back-menu"],
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.handleCloseSubmenu($event)
                }
              }
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$msg("header.back", "header")) + "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: _vm.bemElement("wrapper") }, [
        _c(
          "ul",
          {
            ref: "list",
            class: _vm.bemElement("list", {
              complex: _vm.hasComplexSubCategories
            })
          },
          _vm._l(_vm.categories, function(category, index) {
            return _c("TheMenuItem", {
              key: index,
              attrs: {
                category: category,
                "is-parent-block-category": _vm.isParentBlockCategory,
                "is-secondary-level": true,
                "is-complex-child": _vm.hasComplexSubCategories,
                "is-last-child": index === _vm.categories.length - 1,
                "is-submenu-open": _vm.categoryOpen === category.id
              },
              on: {
                "menu:init-complex-item": _vm.calculateCustomProps,
                "menu:category-open": _vm.toggleSelectedCategory,
                "menu:update-height": _vm.updateSubmenuHeight
              }
            })
          }),
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }